module.exports = ".background-color .row{\r\n    margin-top: 15px;\r\n    padding: 20px 0px 0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/Employee-Separation/emp-retirement-lists/emp-retirement-list/emp-retirement-list.component.css
// module id = ./src/app/hrms/Employee-Separation/emp-retirement-lists/emp-retirement-list/emp-retirement-list.component.css
// module chunks = main